
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.498.126l-7.337 5.5H.955A.968.968 0 000 6.58v6.84c0 .518.422.956.955.956H4.16l7.337 5.498a.626.626 0 001.002-.503c-.002-.374-.001-12.498-.001-18.747 0-.487-.576-.817-1.001-.498zm3.536 4.308c-.719-.086-.958 1.124-.113 1.246 2.207.32 3.829 2.15 3.829 4.318 0 2.169-1.62 4.01-3.83 4.323-.822.081-.64 1.388.176 1.236C17.9 15.161 20 12.791 20 9.998c0-2.929-2.25-5.223-4.966-5.564zm-.228 4.142a1.505 1.505 0 011.033 1.422 1.52 1.52 0 01-1.038 1.43c-.81.25-.354 1.478.415 1.18a2.774 2.774 0 001.873-2.61c0-1.191-.767-2.224-1.883-2.611-.886-.233-1.12.938-.4 1.189z","fill":"#E2E8F0"}})])
          )
        }
      }
    